/* BAMBOOJU — Landing page interactions */
(function () {
  var root = document.documentElement;

  // FAQ: one item open at a time
  document.querySelectorAll('.bmj-faq__list').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item.open) return;
      list.querySelectorAll('.bmj-faq__item[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    }, true);
  });

  // Soft reveal on scroll
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll(
    '.bmj-bento > *, .bmj-agec__card, .bmj-pourquoi__band, .bmj-pourquoi__bento > *, .bmj-remises__head, .bmj-remise, .bmj-deroule__head, .bmj-temo__card, .bmj-faq__left, .bmj-faq__item, .bmj-final__cta, .bmj-final__word'
  );
  root.classList.add('bmj-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (el, i) {
    el.classList.add('bmj-reveal');
    var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.transitionDelay = Math.min(siblings, 5) * 70 + 'ms';
    io.observe(el);
  });
})();
